import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import TableauEnfant from '../components/TableauEnfant'

export default function PageEnfant() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [pseudonyme, setPseudonyme] = useState('')
  const [autorise, setAutorise] = useState(false)

  useEffect(() => {
    supabase.auth.getUser().then(async ({ data }) => {
      if (!data.user) return navigate('/connexion')
      const { data: enfant } = await supabase.from('enfants').select('pseudonyme, parent_id').eq('id', id).single()
      if (!enfant || enfant.parent_id !== data.user.id) return navigate('/tableau-de-bord')
      setPseudonyme(enfant.pseudonyme)
      setAutorise(true)
    })
  }, [id])

  if (!autorise) return null

  return (
    <div style={{ minHeight:'100vh', background:'#f8fafc', fontFamily:"'Inter',sans-serif" }}>
      <header style={{ background:'#fff', borderBottom:'1px solid #e2e8f0', padding:'0 24px', height:52 }}>
        <div style={{ maxWidth:780, margin:'0 auto', height:'100%', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <button onClick={() => navigate('/tableau-de-bord')} style={{ display:'flex', alignItems:'center', gap:6, padding:'5px 10px', borderRadius:6, border:'1px solid #e2e8f0', background:'#fff', color:'#64748b', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              Retour
            </button>
            <div style={{ width:1, height:20, background:'#e2e8f0' }} />
            <div style={{ width:30, height:30, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:14, color:'#2563eb' }}>
                {pseudonyme.charAt(0).toUpperCase()}
              </span>
            </div>
            <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:16, color:'#1e293b' }}>{pseudonyme}</span>
          </div>
          <span style={{ fontSize:11, color:'#94a3b8', background:'#f1f5f9', padding:'3px 10px', borderRadius:20 }}>Vue parents</span>
        </div>
      </header>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <TableauEnfant enfantId={id} estEcole={false} pseudonyme={pseudonyme} />
      </div>
    </div>
  )
}
